import React from 'react';
import { Dna, Globe } from 'lucide-react';
export function GeneticAI() {
  return <section className="py-24 px-6 md:px-12 lg:px-24 bg-white" data-id="element-635">
      <div className="max-w-7xl mx-auto" data-id="element-636">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-637">
          <h2 className="text-4xl md:text-6xl font-bold mb-6" data-id="element-638">
            Generic AI vs. <span className="text-[#0066FF]" data-id="element-639">Genetic AI</span>
          </h2>
          <p className="text-xl text-gray-600 font-light" data-id="element-640">
  Stop wasting tokens on guesses. LLM&apos;s are rapidly becoming 
  interchangeable utilities. They own the compute. <span className="font-bold text-gray-900" data-id="element-641">You own the logic.</span>
        </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-642">
  {/* Generic AI Side */}
  <div className="p-12 bg-gray-50 border border-gray-200 rounded" data-id="element-643">
    <div className="flex items-center gap-3 mb-6" data-id="element-644">
      <Globe className="w-6 h-6 text-gray-400" data-id="element-645" />
      <h3 className="text-2xl font-bold text-gray-500" data-id="element-646">Generic AI</h3>
    </div>
    <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-647">
      A well-read intern. Knows the material, follows patterns, but lacks the situational judgment of your firm.
    </p>
    <div className="h-1 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-648">
      <div className="h-full w-1/3 bg-gray-400" data-id="element-649"></div>
    </div>
  </div>
  
  {/* Genetic AI Side */}
  <div className="p-12 bg-white border border-gray-200 rounded relative overflow-hidden" data-id="element-650">
    <div className="absolute top-0 right-0 w-32 h-32 bg-[#0066FF] opacity-5 blur-[60px] rounded-full" data-id="element-651"></div>
    <div className="flex items-center gap-3 mb-6 relative z-10" data-id="element-652">
      <Dna className="w-6 h-6 text-[#0066FF]" data-id="element-653" />
      <h3 className="text-2xl font-bold text-black" data-id="element-654">Genetic AI</h3>
    </div>
    <p className="text-lg text-black mb-8 leading-relaxed relative z-10" data-id="element-655">
      A seasoned professional trained inside your organization. Applies your standards, judgment, and institutional memory by default.
    </p>
    <div className="h-1 w-full bg-gray-100 rounded-full overflow-hidden" data-id="element-656">
      <div className="h-full w-full bg-[#0066FF]" data-id="element-657"></div>
    </div>
  </div>
      </div>

        {/* Wisdom Moat */}
        <div className="mt-20 p-8 md:p-12 bg-black text-white rounded" data-id="element-658">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center" data-id="element-659">
            <div className="lg:col-span-1" data-id="element-660">
              <h3 className="text-3xl font-bold font-['Syne'] text-[#0066FF]" data-id="element-661">
                The Instruction Layer
              </h3>
            </div>
            <div className="lg:col-span-2" data-id="element-662">
              <p className="text-lg text-gray-300 leading-relaxed" data-id="element-663">
                Your reasoning logic is Enterprise IP. It gives you{' '}
                <strong className="text-white" data-id="element-664">Model Independence</strong>.
                Synthia sits as an independent Instruction Layer, so you
                can swap the underlying 'Generic' model (OpenAI, Anthropic,
                Gemini) in an afternoon without losing a single drop of your
                organization's unique intelligence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}